var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#E6F9EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8721 6.34082L7.37207 11.8408C7.33626 11.8695 7.29867 11.8927 7.25928 11.9106C7.21989 11.9285 7.17513 11.9375 7.125 11.9375C7.07487 11.9375 7.03011 11.9285 6.99072 11.9106C6.95133 11.8927 6.91374 11.8695 6.87793 11.8408L4.47168 9.43457C4.44303 9.39876 4.41976 9.36117 4.40186 9.32178C4.38395 9.28239 4.375 9.23763 4.375 9.1875C4.375 9.0944 4.40902 9.01383 4.47705 8.9458C4.54508 8.87777 4.62565 8.84375 4.71875 8.84375C4.76888 8.84375 4.81364 8.8527 4.85303 8.87061C4.89242 8.88851 4.93001 8.91178 4.96582 8.94043L7.125 11.1104L12.3779 5.84668C12.4137 5.81803 12.4513 5.79476 12.4907 5.77686C12.5301 5.75895 12.5749 5.75 12.625 5.75C12.7181 5.75 12.7987 5.78402 12.8667 5.85205C12.9347 5.92008 12.9688 6.00065 12.9688 6.09375C12.9688 6.14388 12.9598 6.18864 12.9419 6.22803C12.924 6.26742 12.9007 6.30501 12.8721 6.34082Z",
    fill: "#299E60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.0b1cd0c4963b4c7eaf762266f0fc91bf.svg";
export { ForwardRef as ReactComponent };